export default "__VITE_ASSET__DMVP5iH0__"